import { ElementRef, EventEmitter, SimpleChanges } from '@angular/core';
import { HOLDINGS_LAYER_HOLDINGS, HOLDINGS_LAYER_UNDERLYING_HOLDINGS, } from 'SecuritiesApp/ts/constants/holdings-overlap.constants';
import { HoldingsOverlapService } from 'SecuritiesApp/ts/services/holdings-overlap.service';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/holdings-overlap.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../charts/static/charts/ts/features/pie-chart/pie-chart.component";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = () => ({ button: "btn btn-block btn-secondary dropdown-toggle", dropdownMenu: "dropdown-menu-right" });
const _c1 = () => [];
function TopHoldingsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "ycn-single-select-dropdown", 15);
    i0.ɵɵlistener("changeHandler", function TopHoldingsComponent_div_5_Template_ycn_single_select_dropdown_changeHandler_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onHoldingsLayerChange($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c0))("config", ctx_r1.holdingsLayerDropdownConfig)("selectedValue", ctx_r1.holdingsLayer);
} }
function TopHoldingsComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 16);
    i0.ɵɵlistener("click", function TopHoldingsComponent_div_6_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.editHoldingsRedirect()); });
    i0.ɵɵtext(2, "Edit Holdings");
    i0.ɵɵelementEnd()();
} }
function TopHoldingsComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, "No data available");
    i0.ɵɵelementEnd();
} }
function TopHoldingsComponent_tbody_21_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 19)(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 11);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const holding_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", holding_r4.symbol);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", holding_r4.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r4.weighting);
} }
function TopHoldingsComponent_tbody_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, TopHoldingsComponent_tbody_21_tr_1_Template, 7, 3, "tr", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.topHoldings);
} }
function TopHoldingsComponent_tbody_22_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6, "\u00A0");
    i0.ɵɵelementEnd()();
} }
function TopHoldingsComponent_tbody_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 20);
    i0.ɵɵtemplate(1, TopHoldingsComponent_tbody_22_tr_1_Template, 7, 0, "tr", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(4));
} }
const TOP_HOLDINGS_LAYER_DROPDOWN_CONFIG = {
    list: [
        { disabled: false, label: 'Holdings', type: 'option', value: HOLDINGS_LAYER_HOLDINGS },
        { disabled: false, label: 'Underlying Holdings', type: 'option', value: HOLDINGS_LAYER_UNDERLYING_HOLDINGS },
    ],
};
export class TopHoldingsComponent {
    constructor(eltRef, holdingsOverlapService) {
        this.eltRef = eltRef;
        this.holdingsOverlapService = holdingsOverlapService;
        this.limit = 10;
        this.title = '';
        this.editHoldingsUrl = '';
        this.showHoldingsLayerToggle = false;
        this.holdingsLayerDropdownConfig = TOP_HOLDINGS_LAYER_DROPDOWN_CONFIG;
        this.holdingsLayerChange = new EventEmitter();
        this.topHoldings = [];
        this.pieChartData = [];
        this.chartDataJson = '';
        this.tableHasNoData = true;
        this.loading = true;
    }
    ngOnChanges(changes) {
        if (changes.holdingsLayer && !changes.holdingsLayer.firstChange) {
            this.getTopHoldings();
        }
    }
    ngOnInit() {
        if (this.title.length === 0) {
            this.title = `Top ${this.limit} Holdings ${this.displaySecurityId}`;
        }
        this.getTopHoldings();
    }
    editHoldingsRedirect() {
        window.location.href = this.editHoldingsUrl;
    }
    onHoldingsLayerChange(layer) {
        this.holdingsLayerChange.emit(layer);
    }
    getTopHoldings() {
        this.loading = true;
        this.holdingsOverlapService.getTopHoldings(this.securityId, this.limit, this.holdingsLayer).subscribe({
            next: (response) => {
                this.topHoldings = response.holdings_data;
                this.pieChartData = response.chart_data;
                this.chartDataJson = JSON.stringify({
                    chart_data: this.pieChartData,
                });
                this.tableHasNoData = this.topHoldings.length === 0;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
                this.tableHasNoData = true;
            },
        });
    }
}
TopHoldingsComponent.ɵfac = function TopHoldingsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TopHoldingsComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.HoldingsOverlapService)); };
TopHoldingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TopHoldingsComponent, selectors: [["ycn-top-holdings"]], inputs: { securityId: "securityId", displaySecurityId: "displaySecurityId", securityType: "securityType", limit: "limit", holdingsLayer: "holdingsLayer", title: "title", editHoldingsUrl: "editHoldingsUrl", showHoldingsLayerToggle: "showHoldingsLayerToggle", holdingsLayerDropdownConfig: "holdingsLayerDropdownConfig" }, outputs: { holdingsLayerChange: "holdingsLayerChange" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 23, vars: 7, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], ["class", "panel-action", 4, "ngIf"], [1, "panel-content"], [1, "chart-wrap"], [1, "chart-pie"], [3, "chartDataJsonInput"], ["class", "panel-data-empty-message ajust-vertical", "data-test-id", "no-data-available-message", 4, "ngIf"], [1, "table"], [1, "text-right"], [4, "ngIf"], ["data-test-id", "no-data-default-table", 4, "ngIf"], [1, "panel-action"], [3, "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "btn", "btn-text", 3, "click"], ["data-test-id", "no-data-available-message", 1, "panel-data-empty-message", "ajust-vertical"], ["data-test-id", "top-holdings-row-item", 4, "ngFor", "ngForOf"], ["data-test-id", "top-holdings-row-item"], ["data-test-id", "no-data-default-table"], [4, "ngFor", "ngForOf"]], template: function TopHoldingsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, TopHoldingsComponent_div_5_Template, 2, 4, "div", 4)(6, TopHoldingsComponent_div_6_Template, 3, 0, "div", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 5)(8, "div", 6)(9, "div", 7);
        i0.ɵɵelement(10, "ycn-pie-chart", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(11, TopHoldingsComponent_div_11_Template, 2, 0, "div", 9);
        i0.ɵɵelementStart(12, "table", 10)(13, "thead")(14, "tr")(15, "th");
        i0.ɵɵtext(16, "Symbol");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "th");
        i0.ɵɵtext(18, "Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "th", 11);
        i0.ɵɵtext(20, "%\u00A0Weight");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(21, TopHoldingsComponent_tbody_21_Template, 2, 1, "tbody", 12)(22, TopHoldingsComponent_tbody_22_Template, 2, 2, "tbody", 13);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showHoldingsLayerToggle);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.editHoldingsUrl.length > 0);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("chartDataJsonInput", ctx.chartDataJson);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.tableHasNoData);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", !ctx.tableHasNoData);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.tableHasNoData);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.PieChartComponent, i4.SingleSelectDropdownComponent], encapsulation: 2 });
